import styled from "styled-components";
import {SearchLinkBox} from "../../../search-result-item/boxes/search-links/search-link.box";

export const SearchNoGamesFoundDefaultBox = styled(SearchLinkBox)`
    font-size: 1.4rem;
    cursor: default;
    &:before {
        content: "";
        width: 0;
        height: 0;
        margin: 0 
    }
`;